import React from "react";

function Job(props) {
  const { appl } = props;
  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Jobs</h5>
          <hr />
          <div className="row separate-row">
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.total_jobs ?? 0}</h2>
                  <i className={`fa-solid ms-3 ${appl?.total_jobs_flag}`}></i>
                </div>
                <div className="fs-14 d-block mb-2">Total Jobs</div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.live_on_site ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.live_on_site_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Live on Site</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.scheduled_jobs ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.scheduled_jobs_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Scheduled Jobs</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.unverified_jobs ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.unverified_jobs_flag}`}
                    ></i>
                  </div>
                  <span className="fs-14 d-block mb-2">Unverified Jobs</span>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.tech ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <span className="fs-14 d-block mb-2">Tech Jobs</span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.nontech ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <span className="fs-14 d-block mb-2">Non-tech Jobs</span>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.lgbtq_talent ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <span className="fs-14 d-block mb-2">LGBT+ Talent</span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.women_talent ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <div className="fs-14 d-block mb-2">Women Talent</div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.man_talent ?? 0}</h2>
                  <i className={`fa-solid ms-3 fa-arrows-left-right`}></i>
                </div>
                <div className="fs-14 d-block mb-2">Man Talent</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Job;
